module.exports = __webpack_public_path__ + "752a4b58cc46510b0ea5b35e7dcfbf1b.fbx";